export const getContrastColor = (hexcolor: string, lightText: string = "#ffffff", darkText: string = "#000000") => {
    // Increase threshold from 128 to 150-160
    const threshold = 150;

    // Remove hash
    const hex = hexcolor.replace("#", "");
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);

    // YIQ formula (standard for contrast)
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;

    // Return AntD tokens based on brightness
    return yiq >= threshold ? darkText : lightText;
};
